export default __webpack_public_path__ + "static/media/fullbleed1.0bfb9713.jpg";